export var EmissionFactorChangelogInclude = {
    category: {
        select: {
            name: true,
        },
    },
    createdBy: {
        select: {
            firstName: true,
            lastName: true,
        },
    },
    emissionFactor: {
        select: {
            activityDataSource: {
                select: {
                    name: true,
                },
            },
        },
    },
};
//# sourceMappingURL=EmissionFactorChangelog.js.map